export * from '@primeuix/themes/lara/toggleswitch';
export { default } from '@primeuix/themes/lara/toggleswitch';
